import * as React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';
import { translate } from '~l10n/client';

import { queryClient } from '~teacher/queryClient';

import modal from '../../../shared/modal/ModalController';
import model from '../models/RoomsModel';
import SelectNewStudentsView from '../views/SelectNewStudentsView';

class SelectNewStudentsController {
  render(options) {
    modal.render({
      title: translate('Add Students'),
      content: (
        <QueryClientProvider client={queryClient}>
          <SelectNewStudentsView
            controller={controller}
            name={options.room_name}
            roomId={options.roomId}
            studentsInRoom={options.studentsInRoom}
            loader={options.loader}
          />
        </QueryClientProvider>
      ),
    });
  }

  selectedNewClicked(nrOfStudentsToAdd, roomId) {
    model.addStudents(nrOfStudentsToAdd, null, roomId);
  }

  closePopup() {
    modal.closeModal();
  }
}

let controller = new SelectNewStudentsController();
module.exports = controller;
